import { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid'
import { setVolumeProgressionModifier, setExerciseProgressionSlotModifier } from "redux/slices/generator"

export default function ProgressionModifiers() {

    const dispatch = useDispatch()
    const volumeProgressionModifier = useSelector((state) => state.generator.inputs.volumeProgressionModifier)
    const workoutTemplateExerciseProgressionModifiers = useSelector((state) => state.generator.inputs.workoutTemplateExerciseProgressionModifiers)

    const [detailsExpanded, setDetailsExpanded] = useState(false)

    return (
        <div className='bg-white border border-gray-400 p-4 rounded-xl space-y-6'>

            {/* Expand Details Toggle */}
            <div 
                className='flex items-center cursor-pointer gap-x-4'
                onClick={() => setDetailsExpanded(!detailsExpanded)}
            >
                <div className='flex-grow'>Progression Modifiers</div>
                {!detailsExpanded && <ChevronDownIcon className='w-6 h-6 text-gray-400' />}
                {detailsExpanded && <ChevronUpIcon className='w-6 h-6 text-gray-400' />}
            </div>

            {detailsExpanded && 
                <div className='space-y-4'>

                    <div className="text-gray-500">Volume Progression Modifier</div>

                    <input
                        min={0}
                        type="number"
                        name="volumeProgressionModifier"
                        id="volumeProgressionModifier"
                        className='w-full px-4 py-2 rounded-md text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400'
                        value={volumeProgressionModifier}
                        onChange={(event) => dispatch(setVolumeProgressionModifier(parseInt(event.target.value)))}
                    />

                    <div className="text-gray-500">Exercise Progression Modifiers</div>

                    <div className="grid grid-cols-2 gap-x-4">

                        {/* Strength Session A Exercise Progression Modifiers */}
                        <div className="space-y-2">
                            <div className="text-lg font-semibold">Strength Session A</div>
                            {workoutTemplateExerciseProgressionModifiers['strength-session-a'].map((phase, phaseIndex) => (
                                <div 
                                    key={phaseIndex}
                                    className="space-y-1"
                                >
                                    <div>{phase.name}</div>
                                    
                                    <div className="space-y-1">
                                        {phase.slotExerciseProgressionModifiers.map((slotModifier, slotIndex) => (
                                            <input
                                                key={slotIndex}
                                                min={0}
                                                type="number"
                                                name="slotModifier"
                                                id="slotModifier"
                                                className='w-full px-4 py-2 rounded-md text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400'
                                                value={slotModifier}
                                                onChange={(event) => dispatch(setExerciseProgressionSlotModifier({
                                                    workoutTemplateKey: 'strength-session-a',
                                                    phaseIndex: phaseIndex,
                                                    slotIndex: slotIndex,
                                                    newSlotModifier: parseInt(event.target.value)
                                                }))}
                                            />
                                        ))}
                                    </div>

                                </div>
                            ))}
                        </div>

                        {/* Strength Session B Exercise Progression Modifiers */}
                        <div className="space-y-2">
                            <div className="text-lg font-semibold">Strength Session B</div>
                            {workoutTemplateExerciseProgressionModifiers['strength-session-b'].map((phase, phaseIndex) => (
                                <div 
                                    key={phaseIndex}
                                    className="space-y-1"
                                >
                                    <div>{phase.name}</div>
                                    
                                    <div className="space-y-1">
                                        {phase.slotExerciseProgressionModifiers.map((slotModifier, slotIndex) => (
                                            <input
                                                key={slotIndex}
                                                min={0}
                                                type="number"
                                                name="slotModifier"
                                                id="slotModifier"
                                                className='w-full px-4 py-2 rounded-md text-gray-900 shadow-sm ring-1 ring-gray-300 placeholder:text-gray-400'
                                                value={slotModifier}
                                                onChange={(event) => dispatch(setExerciseProgressionSlotModifier({
                                                    workoutTemplateKey: 'strength-session-b',
                                                    phaseIndex: phaseIndex,
                                                    slotIndex: slotIndex,
                                                    newSlotModifier: parseInt(event.target.value)
                                                }))}
                                            />
                                        ))}
                                    </div>

                                </div>
                            ))}
                        </div>

                    </div>
                </div>
            }

        </div>
    )

}